import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import "../CSS/appointment.css"
import AppointmentService from '../utils/AppointmentService.js';
import Select from 'react-select';
//import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'

import {
  BrowserRouter as Router,
  Link,
  Route // for later
} from 'react-router-dom'

export class AddCCForm extends Component {
  constructor(props) {
    super(props)
    this.state ={
      ccNumber: '',
      expMonth: '',
      expYear: '',
      cvc:'',
      cardName:'',
      ccError: null
    }
    this.Appt = new AppointmentService()
  }
  saveCard() {
    var this2 = this
    if(this.props.setLoading){
      this.props.setLoading()
    }
    if(this.props.closeModal){
      this.props.closeModal()
    }
    this.Appt.addCreditCard(this.state.ccNumber, this.state.expMonth, this.state.expYear, this.state.cvc, this.state.cardName)
    .then(res =>{
      if(res && res.id){
        this.Appt.setDefaultCard(res.id)
        .then(res =>{
          this2.props.submitAppointment(res)
        })
        .catch(err =>{
          alert(err)
        })
      }
      else {
        this.setState({
          ccError: res.errors
        })
      }
    })
    .catch(err =>{
      alert(err)
    })
  }
  handleNewCCChange = event => {
      this.setState({
        [event.target.id]: event.target.value
      });
  }
  handleMonthChange = month => {
      this.setState({
        expMonth: month.value
      });
  }
  render() {
    const options = [
      { value: '01', label: 'January' },
      { value: '02', label: 'February' },
      { value: '03', label: 'March' },
      { value: '04', label: 'April' },
      { value: '05', label: 'May' },
      { value: '06', label: 'June' },
      { value: '07', label: 'July' },
      { value: '08', label: 'August' },
      { value: '09', label: 'September' },
      { value: '10', label: 'October' },
      { value: '11', label: 'November' },
      { value: '12', label: 'December' }
    ];
    return (
      <div>
        {this.state.ccError &&
          <p className="whiteText">{this.state.ccError}</p>
        }
      <div className="form-row mb-3">
          <div className="col">
            <input className="form-control ccFormElement form-control-md" type="text" id="ccNumber" value={this.state.ccNumber} onChange={this.handleNewCCChange} placeholder="Credit Card Number" ></input>
          </div>
        </div>
        <div className="form-row mb-3">
          <div className="col">
          <Select
            className="newCCSelect"
            value={this.state.expMonth}
            onChange={this.handleMonthChange}
            options={options}
          />
          </div>
          <div className="col">
            <input className="form-control ccFormElement form-control-md" type="text" id="expYear" value={this.state.expYear} onChange={this.handleNewCCChange} placeholder="Expiration Year"></input>
          </div>
        </div>
        <div className="form-row">
          <div className="col">
            <input className="form-control ccFormElement form-control-md" type="text" id="cardName" value={this.state.cardName} onChange={this.handleNewCCChange} placeholder="Name On Card"></input>
          </div>
          <div className="col">
            <input className="form-control ccFormElement form-control-md" type="text" id="cvc" value={this.state.cvc} onChange={this.handleNewCCChange} placeholder="CVC"></input>
          </div>

        </div>
        <div className="form-group">
          <button className="ccFormElement btn btn-success btn-block text-muted text-center" onClick = {() => this.saveCard()}>Confirm Credit Card</button>
        </div>
        <div className="form-group ccFormElement">
          <button onClick = {() => this.props.closeModal()}className="btn btn-block text-muted text-center">Cancel</button>
        </div>
      </div>
    )
  }
}
export default AddCCForm



// WEBPACK FOOTER //
// ./src/Components/AddCCForm.js